<template>
  <div
    class="footer-pc"
    vkshop-event-scope="footer"
    v-if="!isStudentCenterApp"
  >
    <div class="foot-guide container clearfixnew">
      <div class="service-hotline fl">
        <h5 class="guide-title">客服热线</h5>
        <div class="phone-box">
          <img
            class="phone"
            src="@/assets/images/footer/tel.png"
            alt=""
          >
          <span>95753</span>
        </div>
        <div class="time">周一至周日 08:30～22:00</div>
        <div
          class="btn-ask js-online-service"
          vkshop-event-name="callIM"
          vkshop-event-type="click"
          @click="changeIm()"
        >在线咨询</div>
      </div>
      <div class="company-info fl">
        <h5 class="guide-title">公司信息</h5>
        <p>
          <a href="/web/about">关于我们</a>
        </p>
        <p>
          <a href="/web/cooperation">渠道合作</a>
        </p>
        <p>
          <a href="/web/founder">创始人故事</a>
        </p>
        <p>
          <a href="/web/jobs">加入我们</a>
        </p>
        <p>
          <a href="/web/agreementprivacy">隐私政策</a>
        </p>
        <p>
          <a href="/web/aboutus">媒体报道</a>
        </p>
      </div>
      <div class="production fl">
        <p>
          <a href="/dinosaurgarden">小恐龙乐园</a>
        </p>
        <p>
          <a href="http://teacher-recruitment.vipkid.com.cn/">Teacher Recruitment</a>
        </p>
        <p>
          <a href="/web/faq">常见问题</a>
        </p>
        <p>
          <a href="//www.vipkid.com.cn/posts/list/1.html">青少儿英语知识</a>
        </p>
      </div>
      <div class="focus-info fr">
        <h5 class="guide-title">关注我们</h5>
        <ul class="clearfixnew">
          <li class="fl">
            <div class="icon">
              <img
                class="img"
                src="@/assets/images/footer/icon-wechat.png"
                alt="微信"
              >
              <div class="qrcode-box">
                <img
                  src="@/assets/images/footer/qinzi.png"
                  alt="英文亲子阅读"
                >
                <img
                  class="arrow"
                  src="@/assets/images/footer/arrow-down.png"
                  alt=""
                >
              </div>
            </div>
            <p>VIPKID</p>
            <p>英文亲子阅读</p>
          </li>
          <li class="fl">
            <div class="icon">
              <img
                class="img"
                src="@/assets/images/footer/icon-wechat.png"
                alt="微信"
              >
              <div class="qrcode-box">
                <img
                  src="@/assets/images/footer/ketang.png"
                  alt="家长V课堂"
                >
                <img
                  class="arrow"
                  src="@/assets/images/footer/arrow-down.png"
                  alt=""
                >
              </div>
            </div>
            <p>VIPKID</p>
            <p>家长V课堂</p>
          </li>
          <li class="fl">
            <div class="icon">
              <img
                class="img"
                src="@/assets/images/footer/icon-wechat.png"
                alt="微信"
              >
              <div class="qrcode-box">
                <img
                  src="@/assets/images/footer/youliao.png"
                  alt="有资有料"
                >
                <img
                  class="arrow"
                  src="@/assets/images/footer/arrow-down.png"
                  alt=""
                >
              </div>
            </div>
            <p>VIPKID</p>
            <p>有资有料</p>
          </li>
          <li
            class="fl"
            @click="goToWeibo"
          >
            <div class="icon">
              <img
                class="img"
                src="@/assets/images/footer/icon-weibo.png"
                alt="微博"
              >
            </div>
            <p>VIPKID</p>
            <p>官微</p>
          </li>

        </ul>
        <ul class="clearfixnew secondCon">
          <li class="fl">
            <div class="icon">
              <img
                class="img"
                src="@/assets/images/footer/icon-wechat.png"
                alt="微信"
              >
              <div class="qrcode-box">
                <img
                  src="@/assets/images/footer/fuwuhao.png"
                  alt="服务号"
                >
                <img
                  class="arrow"
                  src="@/assets/images/footer/arrow-down.png"
                  alt=""
                >
              </div>
            </div>
            <p>VIPKID</p>
            <p>服务号</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="foot-container">
      <div class="foot-info container clearfixnew">
        <ul class="authentication fl">
          <li>
            <a href="http://www.itrust.org.cn/Home/Index/wx_certifi/wm/1805016993">
              <img
                src="@/assets/images/footer/renzheng.png"
                alt=""
              ></a>
          </li>
          <li>
            <a href="http://www.315online.com.cn/member/315150028.html">
              <img
                src="@/assets/images/footer/jiaoyi.png"
                alt=""
              ></a>
          </li>
          <li>
            <a href="javascript:;">
              <img
                src="@/assets/images/footer/anxinbao.png"
                alt=""
              ></a>
          </li>
          <li>
            <a href="/inforcertification">
              <img
                src="@/assets/images/footer/inforcertification.png"
                alt=""
              ></a>
          </li>
        </ul>
        <div class="copyright fl">
          <p class="copy">
            <span>© VIPKID 京ICP证 150842号</span>
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102001980"
              target="_blank"
            > <img
                class="icon"
                src="@/assets/images/footer/policeEmblem.png"
              >京公网安备 11010102001980号</a>
            <a
              href="http://www.beian.miit.gov.cn"
              target="_blank"
            >京ICP备14002500号-1</a>
            <span>北京大米科技有限公司</span>
          </p>
          <p class="permit">
            <a
              href="https://www.vipkid.com.cn/businesslicenseone"
              target="_blank"
            >
              <span>出版物经营许可证(京零)字第海170127号</span>
            </a>
            <a
              href="https://www.vipkid.com.cn/businesslicensethree"
              target="_blank"
            >
              <span>广播电视节目制作经营许可证(京)字第08921号</span>
            </a>
            <a
              href="https://www.vipkid.com.cn/businesslicensetwo"
              target="_blank"
            >
              <span class="business-license">营业执照</span>
            </a>
          </p>
          <p class="permit">
            <span>违法和不良信息举报电话：95753</span>
            <span>举报邮箱 VKreport@vipkid.com.cn</span>
            <a href="https://www.12377.cn" target="_blank">
              <span>网上有害信息举报专区</span>
            </a>
          </p>
        </div>
        <div class="country fr">
          <div class="china">
            中国
            <img
              class="china-img"
              src="@/assets/images/footer/angle-up.png"
              alt=""
            >
          </div>
          <div class="national-ul">
            <ul>
              <li>
                <a
                  class="clearfixnew"
                  href="//www.vipkid.com?vk_fromcode=US"
                >
                  <span class="fl">United States</span>
                </a>
              </li>
              <li>
                <a
                  class="clearfixnew"
                  href="https://kr.vipkid.com?vk_fromcode=KR"
                >
                  <span class="fl">한국</span>
                </a>
              </li>
              <li>
                <a
                  class="clearfixnew"
                  href="https://vipkid.com.cn?vk_fromcode=CN"
                >
                  <span class="fl">中国</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imBus from '@/eventBus/imBus.js'

export default {
  name: 'footGuide',
  data() {
    return {
      isStudentCenterApp: window.navigator.userAgent.includes('VIPKID') && window.navigator.userAgent.includes('PCStudent') // 用来判断是否在学习中心app
    }
  },
  methods: {
    goToWeibo() {
      window.location.href = 'http://weibo.com/p/1006065212940492'
    },
    changeIm() {
      imBus.$emit('changeIm')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.footer-pc {
  width: 100%;
  background: #333;
  font-size: 14px;
  .foot-guide {
    box-sizing: border-box;
    // width: 1124px;
    padding: 55px 30px 35px;
    .guide-title {
      width: 65px;
      // height: 22px;
      font-size: 16px;
      color: #fff;
      line-height: 16px;
      position: relative;
      margin-bottom: 40px;
      font-weight: 500;
      &::after {
        content: "";
        width: 28px;
        height: 3px;
        position: absolute;
        background: #f85415;
        bottom: -15px;
        left: 0;
      }
    }
    .service-hotline {
      width: 270px;
      .phone-box {
        height: 36px;
        line-height: 36px;
        margin-bottom: 15px;
        .phone {
          width: 36px;
          height: 36px;
          display: inline-block;
          margin-right: 10px;
          vertical-align: text-bottom;
        }
        span {
          font-weight: 700;
          font-size: 36px;
          color: #fff;
        }
      }
      .time {
        color: #999;
        margin-bottom: 18px;
        line-height: 14px;
      }
      .btn-ask {
        display: block;
        width: 144px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        color: #fff;
        background: #f85415;
        text-align: center;
        border-radius: 20px;
        border: none;
        cursor: pointer;
        &:hover {
          background: #e64507;
        }
      }
    }
    .company-info {
      width: 180px;
      a {
        line-height: 28px;
        color: #999;
      }
    }
    .production {
      width: 255px;
      padding-top: 55px;
      a {
        line-height: 28px;
        color: #999;
      }
    }
    .focus-info {
      li {
        margin-right: 25px;
        cursor: pointer;
        &:hover .qrcode-box {
          display: block;
          animation: wxshow 0.2s ease-in 1 forwards;
        }
        &:last-child {
          margin: 0;
        }
      }
      .icon {
        width: 30px;
        height: 30px;
        margin-bottom: 10px;
        position: relative;
        .img {
          width: 100%;
        }
        .qrcode-box {
          display: none;
          position: absolute;
          left: 50%;
          margin-left: -75px;
          top: -170px;
          z-index: 200;
          padding: 10px;
          width: 150px;
          height: 150px;
          border-radius: 4px;
          background: #fff;
          -webkit-box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.06),
            0 15px 40px 0 rgba(0, 0, 0, 0.12);
          box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.06),
            0 15px 40px 0 rgba(0, 0, 0, 0.12);
          img {
            width: 100%;
          }
          .arrow {
            position: absolute;
            bottom: -8px;
            left: 50%;
            margin-left: -8px;
            width: 18px;
          }
        }
      }
      p {
        margin-top: 4px;
        color: #999;
        line-height: 1;
      }
      .secondCon {
        padding-top: 15px;
      }
    }
  }
  .foot-container {
    height: 70px;
    background: #292929;
    .foot-info {
      padding: 0 20px;
      .authentication {
        height: 70px;
        margin-right: 10px;
        font-size: 0;
        li {
          display: inline-block;
          width: 64px;
          margin: 23px 0 0 6px;
          img {
            width: 100%;
            vertical-align: middle;
          }
        }
      }
    }
    .copyright {
      color: #333;
      padding-top: 8px;
      .copy {
        line-height: 1;
        font-size: 16px;
        span,
        a {
          margin-right: 6px;
          font-size: 12px;
          color: #777;
          .icon {
            display: inline-block;
            width: 16px;
            height: 16px;
            margin: 0 3px 0 7px;
            vertical-align: middle;
          }
        }
      }
      .permit {
        width: 100%;
        padding: 0;
        line-height: 17px;
        a {
          margin-right: 10px;
          line-height: 18px;
        }
        span {
          color: #777;
          font-size: 12px;
          margin-right: 6px;
          &:last-child {
            margin-right: 0;
          }
        }
        .business-license {
          text-decoration: underline;
          margin-right: 10px;
        }
      }
    }
    .country {
      position: relative;
      padding-top: 20px;
      height: 100%;
      cursor: pointer;
      .china {
        position: relative;
        width: 60px;
        height: 28px;
        line-height: 28px;
        padding-left: 6px;
        border: 1px solid #777;
        border-radius: 6px;
        color: #777;
        font-size: 12px;
      }
      .china-img {
        position: absolute;
        top: 6px;
        right: 8px;
        width: 14px;
      }
      .national-ul {
        display: none;
        position: absolute;
        bottom: 45px;
        right: 0;
        z-index: 100;
        padding: 4px 8px;
        width: 110px;
        box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.06),
          0 15px 40px 0 rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        font-size: 12px;
        background-color: #292929;
        border: 1px solid #777;
        a {
          &:hover span {
            color: #fff;
          }
        }
        span {
          display: inline-block;
          width: 100%;
          line-height: 26px;
          color: #777;
        }
      }
      &:hover {
        .national-ul {
          display: block;
        }
      }
    }
  }
}

@keyframes wxshow {
  0% {
    bottom: 50px;
    opacity: 0.2;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=20)";
    filter: alpha(opacity=20);
  }

  100% {
    bottom: 60px;
    opacity: 1;
    -ms-filter: none;
    filter: none;
  }
}
</style>
